import { Flex } from '@blockanalitica/ui';
import { HyperLiquidIcon } from '@/components';
import styled from 'styled-components';

const Icon = styled(HyperLiquidIcon)`
  color: white;

  &:hover {
    color: #97fce4;
  }
`;

type HyperLiquidLinkProps = {
  path: string;
  size?: string;
};

export default function HyperLiquidLink({
  path,
  size = '0'
}: HyperLiquidLinkProps) {
  return (
    <Flex
      as="a"
      // @ts-ignore
      href={`https://hyperevmscan.io/${path}`}
      target="_blank"
      rel="noreferrer"
      alignItems="center">
      <Icon size={size} />
    </Flex>
  );
}
